import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const ZATCA_LABELS = {
  REPORTED: 'Reported', CLEARED: 'Cleared', PENDING: 'Pending', FAILED: 'Failed / Rejected', UNKNOWN: 'Unknown', NOT_SUBMITTED: 'Not submitted',
  EXCLUDED_TEST: 'Excluded (test)', HELD: 'Historical Invoice Reference — Pending Review',
};

// Read-only ZATCA details of one sales document (from the existing zatca record).
export const ZatcaDetailsDialog = ({ txn, onClose }) => {
  const z = txn?.zatca || {};
  const msgs = z.validation ? JSON.stringify(z.validation).slice(0, 600) : null;
  const rows = [
    ['Status', ZATCA_LABELS[txn?.zatca_status] || txn?.zatca_status || 'Not applicable'],
    ['Invoice UUID', z.uuid], ['Invoice counter (ICV)', z.icv], ['Submitted', z.submitted_at], ['Reported / cleared', z.reported_at],
    ['HTTP response', z.http], ['Error', z.error ? String(z.error).slice(0, 400) : null], ['Validation messages', msgs],
  ].filter(([, v]) => v !== undefined && v !== null && v !== '');
  return (
    <Dialog open={!!txn} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-lg" data-testid="zatca-details-dialog">
        <DialogHeader><DialogTitle>ZATCA — {txn?.reference_id}</DialogTitle></DialogHeader>
        <dl className="text-sm space-y-2">
          {rows.map(([k, v]) => (
            <div key={k} className="grid grid-cols-[150px_1fr] gap-2">
              <dt className="text-muted-foreground">{k}</dt>
              <dd className="font-mono text-xs break-all" data-testid={`zatca-detail-${k.toLowerCase().replace(/[^a-z]+/g, '-')}`}>{String(v)}</dd>
            </div>
          ))}
          {!txn?.zatca && <p className="text-xs text-muted-foreground">No ZATCA submission record exists for this document.</p>}
        </dl>
      </DialogContent>
    </Dialog>
  );
};
